import {AfterViewChecked, Component} from "@angular/core";
import {RouterOutlet} from "@angular/router";

declare const lucide: {createIcons: () => void} | undefined;

/**
 * Root component.
 *
 * The Lucide icon library replaces every `<i data-lucide="…">` with an inline
 * SVG. It runs at boot, but Angular re-renders templates on navigation /
 * signal updates, so we re-run `lucide.createIcons()` after every view check.
 * Cheap and idempotent — Lucide skips icons it has already created.
 */
@Component({
    selector: "app-root",
    imports: [RouterOutlet],
    templateUrl: "./app.html",
    styleUrls: ["./app.css"]
})
export class App implements AfterViewChecked {
    ngAfterViewChecked(): void {
        if (typeof lucide !== "undefined") {
            lucide.createIcons();
        }
    }
}
